import React from "react";
import { createRoot } from "react-dom/client";
import $ from "jquery";
import "./index.css";
import App from "./App";

window.$ = $;
window.jQuery = $;

const root = createRoot(document.getElementById("root"));
root.render(<App />);
